export const NX_FREE_OPERATORS = 'FREE_OP';
export const NX_PRODUCT_KEY: 'stc-tv' | 'jawwy-tv' = 'stc-tv';
export const NX_NO_PAYMENT_OPERATORS = 'FREE_OP,NO_OP,NO_OP_FVP';
export const NX_PLUS_TIER_GUID = 'PLUS_TIER';
export const NX_FREE_TIER_GUID = 'FREE_TIER';
export const NX_LEGACY_TIER_GUID = 'PREMIUM_TIER,CLASSIC_TIER,LITE_TIER';
export const NX_LEGACY_PRIMIUM_TIER_GUID = 'PREMIUM_TIER';
export const NX_LEGACY_CLASSIC_TIER_GUID = 'CLASSIC_TIER';
export const NX_LEGACY_LITE_TIER_GUID = 'LITE_TIER';
export const NX_FRESH_BASIC_TIER_OPERATOR = 'FREE_OP';
export const NX_UNSUB_OPERATORS =
    'STC,STC_FVP,VODAFONE_EGY,ORANGE_EGY, ETISALAT_EGY, WE_EGY, ETISALAT_UAE,DU_UAE, OREEDOO_OMN, OMANTEL_OMN, ZAIN_IRQ, ZAIN_JOR, ORANGE_JOR,UMNIAH_JOR,ORANGE_TUN,WE_BROADBAND_EGY, OOREDOO_TUN, DV_MA_ORANGE';
export const SUBSCRIPTION_OTP_LENGTH = 4;
export const NX_NO_OP_OPERATOR = 'NO_OP,NO_OP_FVP';
export const NX_TPAY_OPERATOR =
    'VODAFONE_EGY,ORANGE_EGY, ETISALAT_EGY, WE_EGY, ETISALAT_UAE,DU_UAE, OREEDOO_OMN, OMANTEL_OMN, ZAIN_IRQ, ZAIN_JOR, ORANGE_JOR,UMNIAH_JOR,ORANGE_TUN,WE_BROADBAND_EGY, OOREDOO_TUN, DV_MA_ORANGE';
export const NX_DEFAULT_LEGACY_TIER_GUID = 'CLASSIC_TIER';
export const NX_CDN_BALANCER_ACCOUNT_CODE = 'rockettvdev';
export const NX_IN_APP_ANDROID_OPERATORS = 'IAPP_GOOGLE_FVP,IAPP_GOOGLE';
export const NX_IN_APP_APPLE_OPERATORS = 'INAAP_APPLE_FVP,INAAP_APPLE,IAPP_HUAWEI_FVP';
export const NX_IN_APP_ALL_OPERATORS = 'INAAP_APPLE_FVP,INAAP_APPLE,IAPP_GOOGLE_FVP,IAPP_GOOGLE,IAPP_HUAWEI_FVP';
